<script lang="ts" setup>
defineProps<{ dimmed?: boolean }>();
</script>

<template>
  <div
    :class="dimmed ? 'bg-hell-black-60' : 'bg-hell-black'"
    class="h-wrapper"
  >
    <SvgoLogoH
      :font-controlled="false"
      class="h-logo"
      filled
    />
  </div>
</template>

<style lang="scss" scoped>
.h-wrapper {
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  width: 16px;
  height: 16px;
  border-radius: 999px;
}

.h-logo {
  width: 8px;
  height: 8px;
  color: $white;
}
</style>
